import { Anchor, Box, Heading, Paragraph } from '@zillow/constellation-10';

import StringConstants from '@common/constants/StringConstants';

const CommonQuestions = () => {
  const renderParagraph = ({ title, body }) => (
    <Box>
      <Paragraph textStyle="body-bold">{title}</Paragraph>
      <Paragraph css={{ marginBottom: 'token(spacing.md) !important' }}>{body}</Paragraph>
    </Box>
  );
  return (
    <Box css={{ textAlign: 'center', padding: '60px 16px !important' }}>
      <Heading
        level={2}
        textStyle="heading-sm"
        css={{ textAlign: 'center', marginBottom: 'token(spacing.sm) !important' }}
      >
        Common Questions
      </Heading>
      <Box css={{ maxWidth: '700px', margin: 'auto !important' }}>
        <Box css={{ display: 'grid', gridTemplateColumns: { base: '1fr', md: 'repeat(2, 1fr)' } }}>
          {renderParagraph({
            title: 'Which types of credit cards can I use?',
            body: 'Today you can pay your rent with Visa, ' + 'Mastercard, American Express, or Discover cards.',
          })}
          {renderParagraph({
            title: 'Can I stop a payment that I’ve already scheduled?',
            body: 'Absolutely. It’s easy to stop or cancel any of your ' + "payments that aren't already in progress.",
          })}
          {renderParagraph({
            title: 'Can I make single payments instead of scheduling them in advance?',
            body:
              'Sure, you’re always welcome to make a one-time payment. You ' +
              'can also pay with a credit card one month then directly from ' +
              'your bank account the next month.',
          })}
          {renderParagraph({
            title: `If I have trouble, can I get help from someone at Zillow?`,
            body: (
              <>
                Of course! Email us anytime at&nbsp;
                <Anchor href={`mailto:${StringConstants.LINKS.SUPPORT_EMAIL.zillow}`}>
                  {StringConstants.LINKS.SUPPORT_EMAIL.zillow}
                </Anchor>
                .
              </>
            ),
          })}
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'center' }}>
          <Anchor target="_blank" href={StringConstants.LINKS.FAQ_PAGE.zillow}>
            Read more
          </Anchor>
        </Box>
      </Box>
    </Box>
  );
};

export default CommonQuestions;
